import React from 'react';
import { imageUrl } from '../../utils';

interface ImageBannerProps {
  image: string;
  alt?: string;
  containerClass?: string;
  className?: string;
}

const ImageBanner = ({ 
  image, 
  alt, 
  containerClass,
  className 
}: ImageBannerProps) => {
  const imgSrc = imageUrl(image);

  return (
    <>
      {/* Flower on the left side of screen */}
     
      <section className={containerClass || 'container mx-auto px-4 mb-16'}>
        <div className="rounded-3xl overflow-hidden shadow-2xl">
          <img
            src={imgSrc}
            alt={alt || image}
            className={`w-full h-[65vh] object-cover object-top ${className || ''}`}
          />
        </div>
      </section>
    </>
  );
};

export default ImageBanner;

